module.exports = __webpack_public_path__ + "media/images/emoticons/spa-b1159c44e787b4a8049cd389fe34126f.gif";